import React, { useEffect } from 'react';
import { Collapse, Navbar, Nav } from 'reactstrap';

import NavbarUser from './NavbarUser';
import NavbarModules from './NavbarModules';
import NavbarNotification from './NavbarNotification';
import NavbarMessage from './NavbarMessage';
import useSidebar from 'src/hooks/useSidebar';
import LucideIcon from 'src/componentes/lucide-icon';
import history from '../../history';
import useAuth from 'src/hooks/useAuth';
import ConfigApp from 'src/services/configApp';
import NavbarHelp from './NavbarHelp';

function NavbarComponent() {
  const { changeStatus: changeSidebarStatus, collapsed } = useSidebar();
  const { imagemLogo } = useAuth();

  useEffect(() => {
    //dispatch(setNotifications());
    //dispatch(setMessages());
  }, []);

  let srcLogo = '/logo.png';

  if (imagemLogo && imagemLogo.guid != null)
    srcLogo = `${ConfigApp.ApiUrl}/ArquivoSistema/DownloadImagem?guid=${imagemLogo.guid}`;

  return (
    <Navbar
      fixed="top"
      color="white"
      light
      expand
      style={{
        zIndex: 140,
        transition: 'padding-left 0.35s ease-in-out, left 0.35s ease-in-out',
        paddingLeft: !collapsed
          ? 'calc(260px + 1rem)'
          : 'calc(80px + 1rem)',
      }}
    >
      <LucideIcon
        onClick={changeSidebarStatus}
        size={18}
        icon="menu"
        className="main-menu mr-2"
      />
      <a onClick={() => history.push('/')}>
        <img
          className="logo"
          alt="logo"
          style={{ maxHeight: 16, maxWidth: 64 }}
          src={srcLogo}
        ></img>
      </a>
      <Collapse navbar>
        <Nav
          className="ml-auto"
          style={{ display: 'flex', alignItems: 'center' }}
          navbar
        >
          <NavbarModules />
          <NavbarMessage />
          <NavbarNotification />
          <NavbarHelp />
          <NavbarUser />
        </Nav>
      </Collapse>
    </Navbar>
  );
}

export default NavbarComponent;
